// Eksponering · lån — lån-liste fra Oblinor D1 med sum-rad nederst (mockup).
import { Skeleton } from "@/components/ui/skeleton";
import { formatInt } from "../api/format";
import type { ExposureResponse } from "../api/types";

interface ExposureCardProps {
  data: ExposureResponse | undefined;
  isLoading: boolean;
}

export function ExposureCard({ data, isLoading }: ExposureCardProps) {
  return (
    <div className="glass px-6 py-[22px]">
      <h2 className="m-0 mb-4 flex justify-between text-[13px] font-semibold text-[var(--sub)]">
        Eksponering · lån
        <span className="font-medium text-[var(--faint)]">Oblinor</span>
      </h2>

      {isLoading ? (
        <div className="space-y-2.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-6 bg-[rgba(120,60,10,0.1)]" />
          ))}
        </div>
      ) : !data || data.loans.length === 0 ? (
        <p className="text-[13px] text-[var(--faint)]">Ingen registrerte lån.</p>
      ) : (
        <ul className="tab-num m-0 list-none p-0">
          {data.loans.map((loan) => (
            <li
              key={loan.loanId}
              className="flex justify-between border-t border-[rgba(120,60,10,0.12)] py-[11px] first:border-t-0"
            >
              <span>Lån #{loan.loanId}</span>
              <span className="font-semibold">{formatInt(loan.amount)}</span>
            </li>
          ))}
          <li className="flex justify-between border-t border-[rgba(120,60,10,0.25)] py-[11px] font-bold">
            <span>Sum utestående · {data.loanCount} lån</span>
            <span className="text-[var(--val)]">{formatInt(data.sumUtestaaende)}</span>
          </li>
        </ul>
      )}
    </div>
  );
}
